// // src/services/inventoryService.js
// import {
//   collection,
//   doc,
//   addDoc,
//   getDoc,
//   getDocs,
//   updateDoc,
//   deleteDoc,
//   query,
//   where,
//   orderBy,
//   limit,
//   startAfter,
//   serverTimestamp,
//   increment,
//   writeBatch,
// } from "firebase/firestore";
// import {
//   ref,
//   uploadBytes,
//   getDownloadURL,
//   deleteObject,
//   listAll,
// } from "firebase/storage";
// import { db, storage } from "./firebase";

// /**
//  * Get products for a vendor with pagination and filtering
//  * @param {string} vendorId - Vendor ID
//  * @param {Object} options - Query options
//  * @returns {Object} - { products, lastDoc, total }
//  */
// export const getProducts = async (vendorId, options = {}) => {
//   try {
//     const {
//       pageSize = 10,
//       lastVisible = null,
//       category = null,
//       brand = null,
//       search = "",
//       stockFilter = null,
//       sortBy = "createdAt",
//       sortDirection = "desc"
//     } = options;

//     console.log("Query options:", options);

//     // Create base query - start with vendorId only
//     const productsRef = collection(db, "products");
//     let q = query(
//       productsRef,
//       where("vendorId", "==", vendorId)
//     );

//     // Apply single additional filter to avoid complex composite indexes
//     // Priority: category > brand > stock status
//     if (category) {
//       q = query(q, where("categories", "array-contains", category));
//     } else if (brand) {
//       q = query(q, where("brand", "==", brand));
//     }

//     // Add ordering based on sortBy
//     try {
//       if (sortBy === "createdAt") {
//         q = query(q, orderBy("createdAt", sortDirection));
//       } else if (sortBy === "name") {
//         q = query(q, orderBy("name", sortDirection));
//       } else if (sortBy === "price") {
//         q = query(q, orderBy("price", sortDirection));
//       } else if (sortBy === "stock") {
//         q = query(q, orderBy("stock", sortDirection));
//       } else if (sortBy === "sales") {
//         q = query(q, orderBy("sales", sortDirection));
//       } else {
//         // Default fallback
//         q = query(q, orderBy("createdAt", "desc"));
//       }
//     } catch (error) {
//       console.warn("Ordering failed, using default:", error);
//       q = query(q, orderBy("createdAt", "desc"));
//     }

//     // Apply pagination
//     if (lastVisible) {
//       q = query(q, startAfter(lastVisible), limit(pageSize * 2)); // Get more for client-side filtering
//     } else {
//       q = query(q, limit(pageSize * 2)); // Get more for client-side filtering
//     }

//     // Execute query
//     const querySnapshot = await getDocs(q);

//     // Process products with client-side filtering
//     const allProducts = [];
//     querySnapshot.forEach((doc) => {
//       allProducts.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     // Apply client-side filters
//     let filteredProducts = allProducts;

//     // Search filter
//     if (search.trim()) {
//       const searchLower = search.toLowerCase();
//       filteredProducts = filteredProducts.filter(product => 
//         product.name?.toLowerCase().includes(searchLower) ||
//         product.description?.toLowerCase().includes(searchLower) ||
//         product.sku?.toLowerCase().includes(searchLower) ||
//         product.brand?.toLowerCase().includes(searchLower)
//       );
//     }

//     // Brand filter (if category was used in query)
//     if (category && brand) {
//       filteredProducts = filteredProducts.filter(product => 
//         product.brand === brand
//       );
//     }

//     // Stock filter
//     if (stockFilter && stockFilter !== "all") {
//       filteredProducts = filteredProducts.filter(product => {
//         const stock = product.stock || 0;
//         const lowStockThreshold = product.lowStockThreshold || 10;
        
//         switch (stockFilter) {
//           case "in-stock":
//             return stock > lowStockThreshold;
//           case "low-stock":
//             return stock > 0 && stock <= lowStockThreshold;
//           case "out-of-stock":
//             return stock <= 0;
//           default:
//             return true;
//         }
//       });
//     }

//     // Apply client-side sorting if different from query sort
//     if (sortBy !== "createdAt" && (category || brand)) {
//       filteredProducts.sort((a, b) => {
//         let aValue, bValue;
        
//         switch (sortBy) {
//           case "name":
//             aValue = a.name || "";
//             bValue = b.name || "";
//             break;
//           case "price":
//             aValue = a.price || 0;
//             bValue = b.price || 0;
//             break;
//           case "stock":
//             aValue = a.stock || 0;
//             bValue = b.stock || 0;
//             break;
//           case "sales":
//             aValue = a.sales || 0;
//             bValue = b.sales || 0;
//             break;
//           default:
//             return 0;
//         }

//         if (sortDirection === "asc") {
//           return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
//         } else {
//           return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
//         }
//       });
//     }

//     // Paginate filtered results
//     const startIndex = lastVisible ? 0 : 0; // For simplicity, restart from beginning
//     const paginatedProducts = filteredProducts.slice(startIndex, startIndex + pageSize);

//     // Get last visible document for pagination
//     const lastDoc = querySnapshot.docs[Math.min(paginatedProducts.length - 1, querySnapshot.docs.length - 1)];

//     // Get total count for the current filters
//     const total = filteredProducts.length;
//     const hasMore = filteredProducts.length > pageSize;

//     return { 
//       products: paginatedProducts, 
//       lastDoc: hasMore ? lastDoc : null, 
//       total,
//       hasMore 
//     };

//   } catch (error) {
//     console.error("Error getting products:", error);
    
//     // Fallback: simple query without complex filters
//     try {
//       console.log("Attempting fallback query...");
//       const productsRef = collection(db, "products");
//       const fallbackQuery = query(
//         productsRef,
//         where("vendorId", "==", vendorId),
//         orderBy("createdAt", "desc"),
//         limit(options.pageSize || 10)
//       );
      
//       const querySnapshot = await getDocs(fallbackQuery);
//       const products = [];
      
//       querySnapshot.forEach((doc) => {
//         products.push({
//           id: doc.id,
//           ...doc.data(),
//         });
//       });

//       return { 
//         products, 
//         lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1],
//         total: products.length,
//         hasMore: products.length === (options.pageSize || 10)
//       };
      
//     } catch (fallbackError) {
//       console.error("Fallback query also failed:", fallbackError);
//       throw new Error("Unable to load products. Please check your Firebase indexes.");
//     }
//   }
// };

// /**
//  * Get products with simpler filtering (alternative approach)
//  */
// export const getProductsSimple = async (vendorId, options = {}) => {
//   try {
//     const {
//       pageSize = 10,
//       search = "",
//       category = null,
//       brand = null,
//       stockFilter = null,
//       sortBy = "createdAt",
//       sortDirection = "desc"
//     } = options;

//     // Simple query - just vendor and basic ordering
//     const productsRef = collection(db, "products");
//     let q = query(
//       productsRef,
//       where("vendorId", "==", vendorId),
//       orderBy("createdAt", "desc"),
//       limit(50) // Get more products for client-side filtering
//     );

//     const querySnapshot = await getDocs(q);
//     let products = [];
    
//     querySnapshot.forEach((doc) => {
//       products.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     // Apply all filters on client side
//     if (search.trim()) {
//       const searchLower = search.toLowerCase();
//       products = products.filter(product => 
//         product.name?.toLowerCase().includes(searchLower) ||
//         product.description?.toLowerCase().includes(searchLower) ||
//         product.sku?.toLowerCase().includes(searchLower)
//       );
//     }

//     if (category) {
//       products = products.filter(product => 
//         product.categories?.includes(category)
//       );
//     }

//     if (brand) {
//       products = products.filter(product => 
//         product.brand === brand
//       );
//     }

//     if (stockFilter && stockFilter !== "all") {
//       products = products.filter(product => {
//         const stock = product.stock || 0;
//         const lowStockThreshold = product.lowStockThreshold || 10;
        
//         switch (stockFilter) {
//           case "in-stock":
//             return stock > lowStockThreshold;
//           case "low-stock":
//             return stock > 0 && stock <= lowStockThreshold;
//           case "out-of-stock":
//             return stock <= 0;
//           default:
//             return true;
//         }
//       });
//     }

//     // Sort products
//     products.sort((a, b) => {
//       let aValue, bValue;
      
//       switch (sortBy) {
//         case "name":
//           aValue = (a.name || "").toLowerCase();
//           bValue = (b.name || "").toLowerCase();
//           break;
//         case "price":
//           aValue = a.price || 0;
//           bValue = b.price || 0;
//           break;
//         case "stock":
//           aValue = a.stock || 0;
//           bValue = b.stock || 0;
//           break;
//         case "sales":
//           aValue = a.sales || 0;
//           bValue = b.sales || 0;
//           break;
//         case "createdAt":
//         default:
//           aValue = a.createdAt?.toDate?.() || new Date(0);
//           bValue = b.createdAt?.toDate?.() || new Date(0);
//           break;
//       }

//       if (sortDirection === "asc") {
//         return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
//       } else {
//         return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
//       }
//     });

//     // Paginate
//     const paginatedProducts = products.slice(0, pageSize);

//     return { 
//       products: paginatedProducts, 
//       lastDoc: null, // Simplified pagination
//       total: products.length,
//       hasMore: products.length > pageSize
//     };

//   } catch (error) {
//     console.error("Error in getProductsSimple:", error);
//     throw error;
//   }
// };

// /**
//  * Get a single product by ID
//  * @param {string} productId - Product ID
//  * @returns {Object} - Product data
//  */
// export const getProductById = async (productId) => {
//   try {
//     const productRef = doc(db, "products", productId);
//     const productSnap = await getDoc(productRef);

//     if (productSnap.exists()) {
//       return {
//         id: productSnap.id,
//         ...productSnap.data(),
//       };
//     } else {
//       throw new Error("Product not found");
//     }
//   } catch (error) {
//     console.error("Error getting product:", error);
//     throw error;
//   }
// };

// /**
//  * Add a new product
//  * @param {Object} productData - Product data
//  * @returns {Object} - Created product
//  */
// export const addProduct = async (productData) => {
//   try {
//     // Extract images from productData to handle separately
//     const { images, ...productDataWithoutImages } = productData;
    
//     // Add timestamps
//     const dataWithTimestamps = {
//       ...productDataWithoutImages,
//       createdAt: new Date(),
//       updatedAt: new Date(),
//       imageUrls: [], // Initialize empty imageUrls array
//     };

//     // Add to Firestore first (without images)
//     const docRef = await addDoc(collection(db, "products"), dataWithTimestamps);

//     // Upload images if available
//     const imageUrls = [];

//     if (images && images.length > 0) {
//       for (const [index, image] of images.entries()) {
//         const imageRef = ref(storage, `products/${docRef.id}/images/${index}`);
//         await uploadBytes(imageRef, image);
//         const imageUrl = await getDownloadURL(imageRef);
//         imageUrls.push(imageUrl);
//       }

//       // Update product with image URLs
//       await updateDoc(docRef, { imageUrls });
//     }

//     // Update vendor's product count
//     const vendorRef = doc(db, "vendors", productData.vendorId);
//     await updateDoc(vendorRef, {
//       totalProducts: increment(1),
//     });

//     // Get the created product
//     return {
//       id: docRef.id,
//       ...dataWithTimestamps,
//       imageUrls,
//     };
//   } catch (error) {
//     console.error("Error adding product:", error);
//     throw error;
//   }
// };

// /**
//  * Update an existing product
//  * @param {string} productId - Product ID
//  * @param {Object} productData - Updated product data
//  * @returns {Object} - Updated product
//  */
// export const updateProduct = async (productId, productData) => {
//   try {
//     const productRef = doc(db, "products", productId);

//     // Add timestamp
//     const dataWithTimestamp = {
//       ...productData,
//       updatedAt: new Date(),
//     };

//     // Remove images property if exists (we'll handle it separately)
//     if (dataWithTimestamp.images) {
//       delete dataWithTimestamp.images;
//     }

//     // Update Firestore document
//     await updateDoc(productRef, dataWithTimestamp);

//     // Handle new images if available
//     if (productData.newImages && productData.newImages.length > 0) {
//       // Get existing image URLs
//       const productSnap = await getDoc(productRef);
//       const currentData = productSnap.data();
//       const currentImageUrls = currentData.imageUrls || [];

//       // Upload new images
//       const newImageUrls = [];

//       for (const [index, image] of productData.newImages.entries()) {
//         const imageRef = ref(
//           storage,
//           `products/${productId}/images/${currentImageUrls.length + index}`
//         );
//         await uploadBytes(imageRef, image);
//         const imageUrl = await getDownloadURL(imageRef);
//         newImageUrls.push(imageUrl);
//       }

//       // Update product with combined image URLs
//       const updatedImageUrls = [...currentImageUrls, ...newImageUrls];
//       await updateDoc(productRef, { imageUrls: updatedImageUrls });

//       // Add to the result
//       dataWithTimestamp.imageUrls = updatedImageUrls;
//     }

//     // Handle removed images
//     if (
//       productData.removedImageIndexes &&
//       productData.removedImageIndexes.length > 0
//     ) {
//       // Get current image URLs
//       const productSnap = await getDoc(productRef);
//       const currentData = productSnap.data();
//       const currentImageUrls = currentData.imageUrls || [];

//       // Filter out removed images
//       const updatedImageUrls = currentImageUrls.filter(
//         (_, index) => !productData.removedImageIndexes.includes(index)
//       );

//       // Delete removed images from storage
//       for (const index of productData.removedImageIndexes) {
//         try {
//           const imageRef = ref(
//             storage,
//             `products/${productId}/images/${index}`
//           );
//           await deleteObject(imageRef);
//         } catch (error) {
//           console.error("Error deleting image:", error);
//           // Continue even if deletion fails
//         }
//       }

//       // Update product with remaining image URLs
//       await updateDoc(productRef, { imageUrls: updatedImageUrls });

//       // Add to the result
//       dataWithTimestamp.imageUrls = updatedImageUrls;
//     }

//     // Get the updated product
//     return {
//       id: productId,
//       ...dataWithTimestamp,
//     };
//   } catch (error) {
//     console.error("Error updating product:", error);
//     throw error;
//   }
// };

// /**
//  * Delete a product
//  * @param {string} productId - Product ID
//  * @param {string} vendorId - Vendor ID
//  * @returns {boolean} - Success
//  */
// export const deleteProduct = async (productId, vendorId) => {
//   try {
//     // Delete product document
//     const productRef = doc(db, "products", productId);
//     await deleteDoc(productRef);

//     // Delete all images
//     const imagesRef = ref(storage, `products/${productId}`);

//     try {
//       const imagesList = await listAll(imagesRef);

//       // Delete each item
//       const deletePromises = imagesList.items.map((itemRef) =>
//         deleteObject(itemRef)
//       );

//       await Promise.all(deletePromises);
//     } catch (error) {
//       console.error("Error deleting images:", error);
//       // Continue even if image deletion fails
//     }

//     // Update vendor's product count
//     const vendorRef = doc(db, "vendors", vendorId);
//     await updateDoc(vendorRef, {
//       totalProducts: increment(-1),
//     });

//     return true;
//   } catch (error) {
//     console.error("Error deleting product:", error);
//     throw error;
//   }
// };

// /**
//  * Update product stock
//  * @param {string} productId - Product ID
//  * @param {number} newStock - New stock quantity
//  * @returns {Object} - Updated product
//  */
// export const updateProductStock = async (productId, newStock) => {
//   try {
//     const productRef = doc(db, "products", productId);

//     await updateDoc(productRef, {
//       stock: newStock,
//       updatedAt: new Date(),
//     });

//     // Get the updated product
//     const productSnap = await getDoc(productRef);

//     return {
//       id: productId,
//       ...productSnap.data(),
//     };
//   } catch (error) {
//     console.error("Error updating product stock:", error);
//     throw error;
//   }
// };

// /**
//  * Get product categories
//  * @returns {Array} - Categories
//  */
// export const getProductCategories = async () => {
//   try {
//     const categoriesRef = collection(db, "categories");
//     const querySnapshot = await getDocs(categoriesRef);

//     const categories = [];
//     querySnapshot.forEach((doc) => {
//       categories.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     return categories;
//   } catch (error) {
//     console.error("Error getting categories:", error);
//     throw error;
//   }
// };

// /**
//  * Get product brands
//  * @returns {Array} - Brands
//  */
// export const getProductBrands = async () => {
//   try {
//     const brandsRef = collection(db, "brands");
//     const querySnapshot = await getDocs(brandsRef);

//     const brands = [];
//     querySnapshot.forEach((doc) => {
//       brands.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     return brands;
//   } catch (error) {
//     console.error("Error getting brands:", error);
//     throw error;
//   }
// };

// /**
//  * Get low stock products
//  * @param {string} vendorId - Vendor ID
//  * @param {number} limit - Number of products to return
//  * @returns {Array} - Low stock products
//  */
// export const getLowStockProducts = async (vendorId, limit = 10) => {
//   try {
//     const productsRef = collection(db, "products");
//     const q = query(
//       productsRef,
//       where("vendorId", "==", vendorId),
//       orderBy("stock", "asc"),
//       limit(50) // Get more for filtering
//     );

//     const querySnapshot = await getDocs(q);

//     const products = [];
//     querySnapshot.forEach((doc) => {
//       const product = doc.data();
//       const stock = product.stock || 0;
//       const lowStockThreshold = product.lowStockThreshold || 10;
      
//       // Client-side filter for low stock
//       if (stock > 0 && stock <= lowStockThreshold) {
//         products.push({
//           id: doc.id,
//           ...product,
//         });
//       }
//     });

//     return products.slice(0, limit);
//   } catch (error) {
//     console.error("Error getting low stock products:", error);
//     throw error;
//   }
// };

// /**
//  * Get product statistics
//  * @param {string} vendorId - Vendor ID
//  * @returns {Object} - Product statistics
//  */
// export const getProductStatistics = async (vendorId) => {
//   try {
//     const productsRef = collection(db, "products");
//     const q = query(productsRef, where("vendorId", "==", vendorId));

//     const querySnapshot = await getDocs(q);

//     let totalProducts = 0;
//     let totalValue = 0;
//     let lowStockProducts = 0;
//     let outOfStockProducts = 0;

//     querySnapshot.forEach((doc) => {
//       const product = doc.data();
//       totalProducts++;
//       totalValue += (product.price || 0) * (product.stock || 0);

//       const stock = product.stock || 0;
//       const lowStockThreshold = product.lowStockThreshold || 10;

//       if (stock <= 0) {
//         outOfStockProducts++;
//       } else if (stock <= lowStockThreshold) {
//         lowStockProducts++;
//       }
//     });

//     return {
//       totalProducts,
//       totalValue,
//       lowStockProducts,
//       outOfStockProducts,
//     };
//   } catch (error) {
//     console.error("Error getting product statistics:", error);
//     throw error;
//   }
// };

// /**
//  * Get recently added products
//  * @param {string} vendorId - Vendor ID
//  * @param {number} limit - Number of products to return
//  * @returns {Array} - Recently added products
//  */
// export const getRecentlyAddedProducts = async (vendorId, limit = 5) => {
//   try {
//     const productsRef = collection(db, "products");
//     const q = query(
//       productsRef,
//       where("vendorId", "==", vendorId),
//       orderBy("createdAt", "desc"),
//       limit(limit)
//     );

//     const querySnapshot = await getDocs(q);

//     const products = [];
//     querySnapshot.forEach((doc) => {
//       products.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     return products;
//   } catch (error) {
//     console.error("Error getting recently added products:", error);
//     throw error;
//   }
// };

// /**
//  * Get best selling products
//  * @param {string} vendorId - Vendor ID
//  * @param {number} limit - Number of products to return
//  * @returns {Array} - Best selling products
//  */
// export const getBestSellingProducts = async (vendorId, limit = 5) => {
//   try {
//     const productsRef = collection(db, "products");
//     const q = query(
//       productsRef,
//       where("vendorId", "==", vendorId),
//       orderBy("sales", "desc"),
//       limit(limit)
//     );

//     const querySnapshot = await getDocs(q);

//     const products = [];
//     querySnapshot.forEach((doc) => {
//       products.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     return products;
//   } catch (error) {
//     console.error("Error getting best selling products:", error);
//     throw error;
//   }
// };

// /**
//  * Update multiple products' stock
//  * @param {Array} updates - Array of { productId, stock } objects
//  * @returns {boolean} - Success
//  */
// export const updateBulkStock = async (updates) => {
//   try {
//     // Create a batch
//     const batch = writeBatch(db);

//     // Add updates to batch
//     updates.forEach(({ productId, stock }) => {
//       const productRef = doc(db, "products", productId);
//       batch.update(productRef, {
//         stock,
//         updatedAt: new Date(),
//       });
//     });

//     // Commit the batch
//     await batch.commit();

//     return true;
//   } catch (error) {
//     console.error("Error updating bulk stock:", error);
//     throw error;
//   }
// };

// // Export functions
// export default {
//   getProducts,
//   getProductsSimple,
//   getProductById,
//   addProduct,
//   updateProduct,
//   deleteProduct,
//   updateProductStock,
//   getProductCategories,
//   getProductBrands,
//   getLowStockProducts,
//   getProductStatistics,
//   getRecentlyAddedProducts,
//   getBestSellingProducts,
//   updateBulkStock,
// };



// src/services/inventoryService.js
// src/services/inventoryService.js - UPDATED with multiple brands support
import {
  collection,
  doc,
  addDoc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  startAfter,
  serverTimestamp,
  increment,
  writeBatch,
  Timestamp,
  getStorage,
} from "firebase/firestore";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  listAll,
} from "firebase/storage";
import { db, storage } from "./firebase";


/**
 * Generate unique filename for image uploads
 */
const generateImageFilename = (productId, index, file) => {
  const timestamp = Date.now();
  const extension = file.name.split('.').pop();
  return `products/${productId}/images/${timestamp}_${index}.${extension}`;
};

/**
 * Upload multiple images to Firebase Storage
 */
const uploadImages = async (productId, images) => {
  console.log('Uploading images for product:', productId, 'Count:', images.length);
  const imageUrls = [];
  
  try {
    for (const [index, image] of images.entries()) {
      console.log(`Uploading image ${index + 1}/${images.length}:`, image.name);
      
      const filename = generateImageFilename(productId, index, image);
      const imageRef = ref(storage, filename);
      
      console.log('Upload path:', filename);
      
      // Upload the file
      const snapshot = await uploadBytes(imageRef, image);
      console.log('Upload successful, getting download URL...');
      
      // Get download URL
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log('Download URL obtained:', downloadURL);
      
      imageUrls.push(downloadURL);
    }
    
    console.log('All images uploaded successfully:', imageUrls);
    return imageUrls;
  } catch (error) {
    console.error('Error uploading images:', error);
    throw new Error(`Failed to upload images: ${error.message}`);
  }
};

/**
 * Delete images from Firebase Storage
 */
const deleteImages = async (imageUrls) => {
  console.log('Deleting images:', imageUrls);
  
  for (const imageUrl of imageUrls) {
    try {
      // Extract the storage path from the URL
      const urlParts = imageUrl.split('/');
      const fileName = urlParts[urlParts.length - 1].split('?')[0];
      const productId = urlParts[urlParts.length - 3];
      
      const imagePath = `products/${productId}/images/${fileName}`;
      const imageRef = ref(storage, imagePath);
      
      await deleteObject(imageRef);
      console.log('Deleted image:', imagePath);
    } catch (error) {
      console.error('Error deleting image:', imageUrl, error);
      // Continue with other deletions even if one fails
    }
  }
};

/**
 * Get products for a vendor with pagination and filtering - UPDATED for multiple brands
 */
export const getProducts = async (vendorId, options = {}) => {
  try {
    const {
      pageSize = 10,
      lastVisible = null,
      category = null,
      brand = null,
      search = "",
      stockFilter = null,
      sortBy = "createdAt",
      sortDirection = "desc"
    } = options;

    console.log("Query options:", options);

    const productsRef = collection(db, "products");
    let q = query(
      productsRef,
      where("vendorId", "==", vendorId)
    );

    // Apply filters - support both single brand and multiple brands
    if (category) {
      q = query(q, where("categories", "array-contains", category));
    } else if (brand) {
      // Check if searching for single brand or multiple brands
      if (Array.isArray(brand)) {
        // For multiple brands, we'll filter client-side since Firestore doesn't support array-contains-any with multiple values efficiently
        console.log("Multiple brand filter will be applied client-side:", brand);
      } else {
        // Single brand - check if using old 'brand' field or new 'brands' array
        // We'll handle both cases client-side for consistency
        console.log("Single brand filter will be applied client-side:", brand);
      }
    }

    try {
      if (sortBy === "createdAt") {
        q = query(q, orderBy("createdAt", sortDirection));
      } else if (sortBy === "name") {
        q = query(q, orderBy("name", sortDirection));
      } else if (sortBy === "price") {
        q = query(q, orderBy("price", sortDirection));
      } else if (sortBy === "stock") {
        q = query(q, orderBy("stock", sortDirection));
      } else if (sortBy === "sales") {
        q = query(q, orderBy("sales", sortDirection));
      } else {
        q = query(q, orderBy("createdAt", "desc"));
      }
    } catch (error) {
      console.warn("Ordering failed, using default:", error);
      q = query(q, orderBy("createdAt", "desc"));
    }

    if (lastVisible) {
      q = query(q, startAfter(lastVisible), limit(pageSize * 2));
    } else {
      q = query(q, limit(pageSize * 2));
    }

    const querySnapshot = await getDocs(q);

    const allProducts = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      allProducts.push({
        id: doc.id,
        ...data,
        // Ensure imageUrls is always an array
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        // Handle both old 'brand' field and new 'brands' array for backward compatibility
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : []),
        // Keep original brand field for backward compatibility but ensure brands array exists
        ...(data.brand && !data.brands ? { brands: [data.brand] } : {})
      });
    });

    let filteredProducts = allProducts;

    // Apply client-side filters
    if (search.trim()) {
      const searchLower = search.toLowerCase();
      filteredProducts = filteredProducts.filter(product => 
        product.name?.toLowerCase().includes(searchLower) ||
        product.description?.toLowerCase().includes(searchLower) ||
        product.sku?.toLowerCase().includes(searchLower) ||
        product.partNumber?.toLowerCase().includes(searchLower) ||
        product.serialNumber?.toLowerCase().includes(searchLower) ||
        // Search in old brand field
        product.brand?.toLowerCase().includes(searchLower) ||
        // Search in new brands array
        (product.brands && product.brands.some(brandId => 
          brandId.toLowerCase().includes(searchLower)
        )) ||
        // Search in model compatibility if exists
        (product.modelCompatibility && product.modelCompatibility.some(model => 
          model.toLowerCase().includes(searchLower)
        ))
      );
    }

    // Brand filtering - handle both single brand and multiple brands
    if (brand) {
      if (Array.isArray(brand) && brand.length > 0) {
        // Multiple brand filter
        filteredProducts = filteredProducts.filter(product => {
          // Check new brands array
          if (product.brands && product.brands.some(brandId => brand.includes(brandId))) {
            return true;
          }
          // Check old brand field for backward compatibility
          if (product.brand && brand.includes(product.brand)) {
            return true;
          }
          return false;
        });
      } else if (typeof brand === 'string' && brand) {
        // Single brand filter
        filteredProducts = filteredProducts.filter(product => {
          // Check new brands array
          if (product.brands && product.brands.includes(brand)) {
            return true;
          }
          // Check old brand field for backward compatibility
          if (product.brand === brand) {
            return true;
          }
          return false;
        });
      }
    }

    // Category and brand combination filter
    if (category && brand) {
      filteredProducts = filteredProducts.filter(product => {
        const hasCategory = product.categories?.includes(category);
        let hasBrand = false;
        
        if (Array.isArray(brand)) {
          hasBrand = product.brands?.some(brandId => brand.includes(brandId)) || 
                    brand.includes(product.brand);
        } else {
          hasBrand = product.brands?.includes(brand) || product.brand === brand;
        }
        
        return hasCategory && hasBrand;
      });
    }

    // Stock filter
    if (stockFilter && stockFilter !== "all") {
      filteredProducts = filteredProducts.filter(product => {
        const stock = product.stock || 0;
        const lowStockThreshold = product.lowStockThreshold || 10;
        
        switch (stockFilter) {
          case "in-stock":
            return stock > lowStockThreshold;
          case "low-stock":
            return stock > 0 && stock <= lowStockThreshold;
          case "out-of-stock":
            return stock <= 0;
          default:
            return true;
        }
      });
    }

    // Client-side sorting for filtered results
    if (sortBy !== "createdAt" && (category || brand)) {
      filteredProducts.sort((a, b) => {
        let aValue, bValue;
        
        switch (sortBy) {
          case "name":
            aValue = a.name || "";
            bValue = b.name || "";
            break;
          case "price":
            aValue = a.price || 0;
            bValue = b.price || 0;
            break;
          case "stock":
            aValue = a.stock || 0;
            bValue = b.stock || 0;
            break;
          case "sales":
            aValue = a.sales || 0;
            bValue = b.sales || 0;
            break;
          default:
            return 0;
        }

        if (sortDirection === "asc") {
          return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
        } else {
          return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
        }
      });
    }

    const startIndex = lastVisible ? 0 : 0;
    const paginatedProducts = filteredProducts.slice(startIndex, startIndex + pageSize);

    const lastDoc = querySnapshot.docs[Math.min(paginatedProducts.length - 1, querySnapshot.docs.length - 1)];

    const total = filteredProducts.length;
    const hasMore = filteredProducts.length > pageSize;

    return { 
      products: paginatedProducts, 
      lastDoc: hasMore ? lastDoc : null, 
      total,
      hasMore 
    };

  } catch (error) {
    console.error("Error getting products:", error);
    
    try {
      console.log("Attempting fallback query...");
      const productsRef = collection(db, "products");
      const fallbackQuery = query(
        productsRef,
        where("vendorId", "==", vendorId),
        orderBy("createdAt", "desc"),
        limit(options.pageSize || 10)
      );
      
      const querySnapshot = await getDocs(fallbackQuery);
      const products = [];
      
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        products.push({
          id: doc.id,
          ...data,
          imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
          brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
        });
      });

      return { 
        products, 
        lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1],
        total: products.length,
        hasMore: products.length === (options.pageSize || 10)
      };
      
    } catch (fallbackError) {
      console.error("Fallback query also failed:", fallbackError);
      throw new Error("Unable to load products. Please check your Firebase indexes.");
    }
  }
};

/**
 * Get products with simpler filtering - UPDATED for multiple brands
 */
export const getProductsSimple = async (vendorId, options = {}) => {
  try {
    const {
      pageSize = 10,
      search = "",
      category = null,
      brand = null,
      stockFilter = null,
      sortBy = "createdAt",
      sortDirection = "desc"
    } = options;

    const productsRef = collection(db, "products");
    let q = query(
      productsRef,
      where("vendorId", "==", vendorId),
      orderBy("createdAt", "desc"),
      limit(50)
    );

    const querySnapshot = await getDocs(q);
    let products = [];
    
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      products.push({
        id: doc.id,
        ...data,
        // Ensure imageUrls is always an array
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        // Handle both old 'brand' field and new 'brands' array for backward compatibility
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
      });
    });

    // Apply client-side filters
    if (search.trim()) {
      const searchLower = search.toLowerCase();
      products = products.filter(product => 
        product.name?.toLowerCase().includes(searchLower) ||
        product.description?.toLowerCase().includes(searchLower) ||
        product.sku?.toLowerCase().includes(searchLower) ||
        product.partNumber?.toLowerCase().includes(searchLower) ||
        product.serialNumber?.toLowerCase().includes(searchLower) ||
        // Search in old brand field
        product.brand?.toLowerCase().includes(searchLower) ||
        // Search in new brands array
        (product.brands && product.brands.some(brandId => 
          brandId.toLowerCase().includes(searchLower)
        )) ||
        // Search in model compatibility
        (product.modelCompatibility && product.modelCompatibility.some(model => 
          model.toLowerCase().includes(searchLower)
        ))
      );
    }

    if (category) {
      products = products.filter(product => 
        product.categories?.includes(category)
      );
    }

    // Handle both single brand and multiple brands
    if (brand) {
      if (Array.isArray(brand) && brand.length > 0) {
        products = products.filter(product => {
          // Check new brands array
          if (product.brands && product.brands.some(brandId => brand.includes(brandId))) {
            return true;
          }
          // Check old brand field for backward compatibility
          if (product.brand && brand.includes(product.brand)) {
            return true;
          }
          return false;
        });
      } else if (typeof brand === 'string' && brand) {
        products = products.filter(product => {
          // Check new brands array
          if (product.brands && product.brands.includes(brand)) {
            return true;
          }
          // Check old brand field for backward compatibility
          if (product.brand === brand) {
            return true;
          }
          return false;
        });
      }
    }

    if (stockFilter && stockFilter !== "all") {
      products = products.filter(product => {
        const stock = product.stock || 0;
        const lowStockThreshold = product.lowStockThreshold || 10;
        
        switch (stockFilter) {
          case "in-stock":
            return stock > lowStockThreshold;
          case "low-stock":
            return stock > 0 && stock <= lowStockThreshold;
          case "out-of-stock":
            return stock <= 0;
          default:
            return true;
        }
      });
    }

    products.sort((a, b) => {
      let aValue, bValue;
      
      switch (sortBy) {
        case "name":
          aValue = (a.name || "").toLowerCase();
          bValue = (b.name || "").toLowerCase();
          break;
        case "price":
          aValue = a.price || 0;
          bValue = b.price || 0;
          break;
        case "stock":
          aValue = a.stock || 0;
          bValue = b.stock || 0;
          break;
        case "sales":
          aValue = a.sales || 0;
          bValue = b.sales || 0;
          break;
        case "createdAt":
        default:
          aValue = a.createdAt?.toDate?.() || new Date(0);
          bValue = b.createdAt?.toDate?.() || new Date(0);
          break;
      }

      if (sortDirection === "asc") {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      } else {
        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
      }
    });

    const paginatedProducts = products.slice(0, pageSize);

    return { 
      products: paginatedProducts, 
      lastDoc: null,
      total: products.length,
      hasMore: products.length > pageSize
    };

  } catch (error) {
    console.error("Error in getProductsSimple:", error);
    throw error;
  }
};

/**
 * Get a single product by ID - UPDATED to handle multiple brands
 */
export const getProductById = async (productId) => {
  try {
    console.log('Getting product by ID:', productId);
    const productRef = doc(db, "products", productId);
    const productSnap = await getDoc(productRef);

    if (productSnap.exists()) {
      const data = productSnap.data();
      console.log('Product data retrieved:', data);
      
      return {
        id: productSnap.id,
        ...data,
        // Ensure imageUrls is always an array
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        // Handle both old 'brand' field and new 'brands' array for backward compatibility
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
      };
    } else {
      throw new Error("Product not found");
    }
  } catch (error) {
    console.error("Error getting product:", error);
    throw error;
  }
};

/**
 * Add a new product - UPDATED to handle multiple brands
 */
export const addProduct = async (productData) => {
  try {
    console.log('Adding product with data:', productData);
    
    // Extract images from productData to handle separately
    const { images, ...productDataWithoutImages } = productData;
    
    // Ensure brands is always an array and handle backward compatibility
    const processedData = {
      ...productDataWithoutImages,
      brands: Array.isArray(productDataWithoutImages.brands) 
        ? productDataWithoutImages.brands 
        : (productDataWithoutImages.brand ? [productDataWithoutImages.brand] : []),
      createdAt: new Date(),
      updatedAt: new Date(),
      imageUrls: [], // Initialize empty imageUrls array
    };

    // Remove old brand field if it exists (we now use brands array)
    if (processedData.brand) {
      delete processedData.brand;
    }

    console.log('Adding product to Firestore with processed data:', processedData);
    
    // Add to Firestore first (without images)
    const docRef = await addDoc(collection(db, "products"), processedData);
    console.log('Product added to Firestore with ID:', docRef.id);

    // Upload images if available
    let imageUrls = [];

    if (images && images.length > 0) {
      console.log('Uploading images...');
      imageUrls = await uploadImages(docRef.id, images);
      
      // Update product with image URLs
      console.log('Updating product with image URLs:', imageUrls);
      await updateDoc(docRef, { imageUrls });
    }

    // Update vendor's product count
    console.log('Updating vendor product count...');
    const vendorRef = doc(db, "vendors", productData.vendorId);
    await updateDoc(vendorRef, {
      totalProducts: increment(1),
    });

    console.log('Product added successfully');

    // Return the created product
    return {
      id: docRef.id,
      ...processedData,
      imageUrls,
    };
  } catch (error) {
    console.error("Error adding product:", error);
    throw new Error(`Failed to add product: ${error.message}`);
  }
};

/**
 * Update an existing product - UPDATED to handle multiple brands
 */
export const updateProduct = async (productId, productData) => {
  try {
    console.log('Updating product:', productId, 'with data:', productData);
    
    const productRef = doc(db, "products", productId);

    // Get current product data
    const currentProductSnap = await getDoc(productRef);
    if (!currentProductSnap.exists()) {
      throw new Error('Product not found');
    }
    
    const currentData = currentProductSnap.data();
    let currentImageUrls = Array.isArray(currentData.imageUrls) ? [...currentData.imageUrls] : [];
    
    console.log('Current image URLs:', currentImageUrls);

    // Extract images from productData
    const { images, removedImageIndexes, ...productDataWithoutImages } = productData;

    // Ensure brands is always an array and handle backward compatibility
    const processedData = {
      ...productDataWithoutImages,
      brands: Array.isArray(productDataWithoutImages.brands) 
        ? productDataWithoutImages.brands 
        : (productDataWithoutImages.brand ? [productDataWithoutImages.brand] : []),
    };

    // Remove old brand field if it exists (we now use brands array)
    if (processedData.brand) {
      delete processedData.brand;
    }

    // Handle removed images first
    if (removedImageIndexes && removedImageIndexes.length > 0) {
      console.log('Removing images at indexes:', removedImageIndexes);
      
      // Get URLs of images to be removed
      const imagesToRemove = removedImageIndexes
        .filter(index => index < currentImageUrls.length)
        .map(index => currentImageUrls[index]);
      
      console.log('Images to be removed:', imagesToRemove);
      
      // Delete from storage
      if (imagesToRemove.length > 0) {
        await deleteImages(imagesToRemove);
      }
      
      // Remove from current URLs array
      currentImageUrls = currentImageUrls.filter((_, index) => 
        !removedImageIndexes.includes(index)
      );
      
      console.log('Remaining image URLs after removal:', currentImageUrls);
    }

    // Upload new images if available
    if (images && images.length > 0) {
      console.log('Uploading new images:', images.length);
      const newImageUrls = await uploadImages(productId, images);
      console.log('New image URLs:', newImageUrls);
      
      // Add new URLs to current URLs
      currentImageUrls = [...currentImageUrls, ...newImageUrls];
      console.log('Combined image URLs:', currentImageUrls);
    }

    // Prepare update data
    const updateData = {
      ...processedData,
      imageUrls: currentImageUrls,
      updatedAt: new Date(),
    };

    console.log('Final update data:', updateData);

    // Update Firestore document
    await updateDoc(productRef, updateData);
    console.log('Product updated successfully');

    // Return the updated product
    return {
      id: productId,
      ...updateData,
    };
  } catch (error) {
    console.error("Error updating product:", error);
    throw new Error(`Failed to update product: ${error.message}`);
  }
};

/**
 * Delete a product
 */
export const deleteProduct = async (productId, vendorId) => {
  try {
    console.log('Deleting product:', productId);
    
    // Get product data first to get image URLs
    const productRef = doc(db, "products", productId);
    const productSnap = await getDoc(productRef);
    
    if (productSnap.exists()) {
      const productData = productSnap.data();
      const imageUrls = productData.imageUrls || [];
      
      // Delete images from storage
      if (imageUrls.length > 0) {
        await deleteImages(imageUrls);
      }
    }

    // Delete product document
    await deleteDoc(productRef);

    // Update vendor's product count
    const vendorRef = doc(db, "vendors", vendorId);
    await updateDoc(vendorRef, {
      totalProducts: increment(-1),
    });

    console.log('Product deleted successfully');
    return true;
  } catch (error) {
    console.error("Error deleting product:", error);
    throw new Error(`Failed to delete product: ${error.message}`);
  }
};

/**
 * Update product stock - UPDATED to handle multiple brands
 */
export const updateProductStock = async (productId, newStock) => {
  try {
    const productRef = doc(db, "products", productId);

    await updateDoc(productRef, {
      stock: newStock,
      updatedAt: new Date(),
    });

    // Get the updated product
    const productSnap = await getDoc(productRef);
    const data = productSnap.data();

    return {
      id: productId,
      ...data,
      imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
      brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
    };
  } catch (error) {
    console.error("Error updating product stock:", error);
    throw error;
  }
};

/**
 * Get product categories
 */
export const getProductCategories = async () => {
  try {
    const categoriesRef = collection(db, "categories");
    const querySnapshot = await getDocs(categoriesRef);

    const categories = [];
    querySnapshot.forEach((doc) => {
      categories.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return categories;
  } catch (error) {
    console.error("Error getting categories:", error);
    throw error;
  }
};

/**
 * Get product brands - UPDATED to include model count and better structure
 */
export const getProductBrands = async () => {
  try {
    const brandsRef = collection(db, "brands");
    const q = query(brandsRef, where("isActive", "==", true), orderBy("name", "asc"));
    const querySnapshot = await getDocs(q);

    const brands = [];
    querySnapshot.forEach((doc) => {
      const brandData = doc.data();
      brands.push({
        id: doc.id,
        ...brandData,
        modelCount: (brandData.models || []).length // Add model count for reference
      });
    });

    return brands;
  } catch (error) {
    console.error("Error getting brands:", error);
    // Fallback to simpler query if the above fails
    try {
      const brandsRef = collection(db, "brands");
      const querySnapshot = await getDocs(brandsRef);

      const brands = [];
      querySnapshot.forEach((doc) => {
        const brandData = doc.data();
        brands.push({
          id: doc.id,
          ...brandData,
          modelCount: (brandData.models || []).length
        });
      });

      return brands;
    } catch (fallbackError) {
      console.error("Fallback brands query also failed:", fallbackError);
      throw fallbackError;
    }
  }
};

/**
 * Get low stock products - UPDATED to handle multiple brands
 */
export const getLowStockProducts = async (vendorId, limit = 10) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(
      productsRef,
      where("vendorId", "==", vendorId),
      orderBy("stock", "asc"),
      limit(50)
    );

    const querySnapshot = await getDocs(q);

    const products = [];
    querySnapshot.forEach((doc) => {
      const product = doc.data();
      const stock = product.stock || 0;
      const lowStockThreshold = product.lowStockThreshold || 10;
      
      // Client-side filter for low stock
      if (stock > 0 && stock <= lowStockThreshold) {
        products.push({
          id: doc.id,
          ...product,
          imageUrls: Array.isArray(product.imageUrls) ? product.imageUrls : [],
          brands: Array.isArray(product.brands) ? product.brands : (product.brand ? [product.brand] : [])
        });
      }
    });

    return products.slice(0, limit);
  } catch (error) {
    console.error("Error getting low stock products:", error);
    throw error;
  }
};

/**
 * Get product statistics
 */
export const getProductStatistics = async (vendorId) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(productsRef, where("vendorId", "==", vendorId));

    const querySnapshot = await getDocs(q);

    let totalProducts = 0;
    let totalValue = 0;
    let lowStockProducts = 0;
    let outOfStockProducts = 0;

    querySnapshot.forEach((doc) => {
      const product = doc.data();
      totalProducts++;
      totalValue += (product.price || 0) * (product.stock || 0);

      const stock = product.stock || 0;
      const lowStockThreshold = product.lowStockThreshold || 10;

      if (stock <= 0) {
        outOfStockProducts++;
      } else if (stock <= lowStockThreshold) {
        lowStockProducts++;
      }
    });

    return {
      totalProducts,
      totalValue,
      lowStockProducts,
      outOfStockProducts,
    };
  } catch (error) {
    console.error("Error getting product statistics:", error);
    throw error;
  }
};

/**
 * Get recently added products - UPDATED to handle multiple brands
 */
export const getRecentlyAddedProducts = async (vendorId, limit = 5) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(
      productsRef,
      where("vendorId", "==", vendorId),
      orderBy("createdAt", "desc"),
      limit(limit)
    );

    const querySnapshot = await getDocs(q);

    const products = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      products.push({
        id: doc.id,
        ...data,
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
      });
    });

    return products;
  } catch (error) {
    console.error("Error getting recently added products:", error);
    throw error;
  }
};

/**
 * Get best selling products - UPDATED to handle multiple brands
 */
export const getBestSellingProducts = async (vendorId, limit = 5) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(
      productsRef,
      where("vendorId", "==", vendorId),
      orderBy("sales", "desc"),
      limit(limit)
    );

    const querySnapshot = await getDocs(q);

    const products = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      products.push({
        id: doc.id,
        ...data,
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
      });
    });

    return products;
  } catch (error) {
    console.error("Error getting best selling products:", error);
    throw error;
  }
};

/**
 * Update multiple products' stock
 */
export const updateBulkStock = async (updates) => {
  try {
    // Create a batch
    const batch = writeBatch(db);

    // Add updates to batch
    updates.forEach(({ productId, stock }) => {
      const productRef = doc(db, "products", productId);
      batch.update(productRef, {
        stock,
        updatedAt: new Date(),
      });
    });

    // Commit the batch
    await batch.commit();

    return true;
  } catch (error) {
    console.error("Error updating bulk stock:", error);
    throw error;
  }
};

/**
 * Search products by model compatibility - NEW FUNCTION
 */
export const searchProductsByModel = async (vendorId, modelName, brandIds = null) => {
  try {
    const productsRef = collection(db, "products");
    let q = query(
      productsRef,
      where("vendorId", "==", vendorId)
    );

    const querySnapshot = await getDocs(q);
    const products = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const product = {
        id: doc.id,
        ...data,
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
      };

      // Check if product matches the model
      const modelMatch = product.modelCompatibility?.some(model => 
        model.toLowerCase().includes(modelName.toLowerCase())
      );

      // Check if product matches the brand (if specified)
      let brandMatch = true;
      if (brandIds && brandIds.length > 0) {
        brandMatch = product.brands?.some(brandId => brandIds.includes(brandId)) ||
                    (product.brand && brandIds.includes(product.brand));
      }

      if (modelMatch && brandMatch) {
        products.push(product);
      }
    });

    return products;
  } catch (error) {
    console.error("Error searching products by model:", error);
    throw error;
  }
};

/**
 * Get products by multiple brands - NEW FUNCTION
 */
export const getProductsByBrands = async (vendorId, brandIds, options = {}) => {
  try {
    const { pageSize = 10, search = "" } = options;
    
    const productsRef = collection(db, "products");
    const q = query(
      productsRef,
      where("vendorId", "==", vendorId),
      orderBy("createdAt", "desc"),
      limit(50)
    );

    const querySnapshot = await getDocs(q);
    let products = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const product = {
        id: doc.id,
        ...data,
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
      };

      // Filter by brands
      const brandMatch = product.brands?.some(brandId => brandIds.includes(brandId)) ||
                        (product.brand && brandIds.includes(product.brand));

      if (brandMatch) {
        products.push(product);
      }
    });

    // Apply search filter if provided
    if (search.trim()) {
      const searchLower = search.toLowerCase();
      products = products.filter(product => 
        product.name?.toLowerCase().includes(searchLower) ||
        product.description?.toLowerCase().includes(searchLower) ||
        product.sku?.toLowerCase().includes(searchLower) ||
        product.partNumber?.toLowerCase().includes(searchLower)
      );
    }

    return {
      products: products.slice(0, pageSize),
      total: products.length,
      hasMore: products.length > pageSize
    };
  } catch (error) {
    console.error("Error getting products by brands:", error);
    throw error;
  }
};



/**
 * Get models for specific brands - UPDATED to work with your Firebase structure
 */
export const getModelsByBrands = async (brandIds) => {
  try {
    console.log('Fetching models for brands:', brandIds);
    
    if (!brandIds || brandIds.length === 0) {
      return [];
    }

    const brandsRef = collection(db, "brands");
    const allModels = [];

    // Fetch each brand document to get its models array
    for (const brandId of brandIds) {
      try {
        const brandDoc = await getDoc(doc(db, "brands", brandId));
        if (brandDoc.exists()) {
          const brandData = brandDoc.data();
          const brandModels = brandData.models || [];
          
          // Convert model strings to objects with brand info
          const modelsWithBrandInfo = brandModels.map((modelName, index) => ({
            id: `${brandId}_model_${index}`,
            name: modelName,
            brandId: brandId,
            brandName: brandData.name || 'Unknown Brand',
            category: brandData.category || brandData.type || 'motorcycle',
            logo: brandData.logo || null
          }));
          
          allModels.push(...modelsWithBrandInfo);
        }
      } catch (error) {
        console.error(`Error fetching brand ${brandId}:`, error);
      }
    }

    console.log('Found models:', allModels.length);
    return allModels;
  } catch (error) {
    console.error("Error getting models by brands:", error);
    return [];
  }
};

/**
 * Get all models from all brands - UPDATED to work with your Firebase structure
 */
export const getAllModels = async () => {
  try {
    const brandsRef = collection(db, "brands");
    const q = query(brandsRef, where("isActive", "==", true), orderBy("name", "asc"));
    const querySnapshot = await getDocs(q);

    const allModels = [];

    querySnapshot.forEach((doc) => {
      const brandData = doc.data();
      const brandModels = brandData.models || [];
      
      const modelsWithBrandInfo = brandModels.map((modelName, index) => ({
        id: `${doc.id}_model_${index}`,
        name: modelName,
        brandId: doc.id,
        brandName: brandData.name || 'Unknown Brand',
        category: brandData.category || brandData.type || 'motorcycle',
        logo: brandData.logo || null
      }));
      
      allModels.push(...modelsWithBrandInfo);
    });

    // Sort models by name
    allModels.sort((a, b) => a.name.localeCompare(b.name));

    return allModels;
  } catch (error) {
    console.error("Error getting all models:", error);
    
    // Fallback without isActive filter
    try {
      const brandsRef = collection(db, "brands");
      const querySnapshot = await getDocs(brandsRef);

      const allModels = [];

      querySnapshot.forEach((doc) => {
        const brandData = doc.data();
        const brandModels = brandData.models || [];
        
        const modelsWithBrandInfo = brandModels.map((modelName, index) => ({
          id: `${doc.id}_model_${index}`,
          name: modelName,
          brandId: doc.id,
          brandName: brandData.name || 'Unknown Brand',
          category: brandData.category || brandData.type || 'motorcycle',
          logo: brandData.logo || null
        }));
        
        allModels.push(...modelsWithBrandInfo);
      });

      allModels.sort((a, b) => a.name.localeCompare(b.name));
      return allModels;
    } catch (fallbackError) {
      console.error("Fallback query also failed:", fallbackError);
      return [];
    }
  }
};

/**
 * Search models by name across selected brands - UPDATED
 */
export const searchModelsByName = async (searchTerm, brandIds = null) => {
  try {
    if (!searchTerm || searchTerm.length < 2) {
      // If no search term, return models for selected brands
      if (brandIds && brandIds.length > 0) {
        return await getModelsByBrands(brandIds);
      }
      return [];
    }

    const brandsRef = collection(db, "brands");
    let querySnapshot;

    if (brandIds && brandIds.length > 0) {
      // Search within specific brands - we'll fetch each brand individually
      const allModels = [];
      
      for (const brandId of brandIds) {
        try {
          const brandDoc = await getDoc(doc(db, "brands", brandId));
          if (brandDoc.exists()) {
            const brandData = brandDoc.data();
            const brandModels = brandData.models || [];
            
            // Filter models by search term
            const filteredModels = brandModels
              .filter(modelName => 
                modelName.toLowerCase().includes(searchTerm.toLowerCase())
              )
              .map((modelName, index) => ({
                id: `${brandId}_model_${index}`,
                name: modelName,
                brandId: brandId,
                brandName: brandData.name || 'Unknown Brand',
                category: brandData.category || brandData.type || 'motorcycle',
                logo: brandData.logo || null
              }));
            
            allModels.push(...filteredModels);
          }
        } catch (error) {
          console.error(`Error searching brand ${brandId}:`, error);
        }
      }
      
      return allModels.slice(0, 50); // Limit results
    } else {
      // Search across all brands
      const q = query(brandsRef, orderBy("name", "asc"));
      querySnapshot = await getDocs(q);

      const allModels = [];

      querySnapshot.forEach((doc) => {
        const brandData = doc.data();
        const brandModels = brandData.models || [];
        
        // Filter models by search term
        const filteredModels = brandModels
          .filter(modelName => 
            modelName.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((modelName, index) => ({
            id: `${doc.id}_model_${index}`,
            name: modelName,
            brandId: doc.id,
            brandName: brandData.name || 'Unknown Brand',
            category: brandData.category || brandData.type || 'motorcycle',
            logo: brandData.logo || null
          }));
        
        allModels.push(...filteredModels);
      });

      // Sort by relevance (exact matches first, then partial matches)
      allModels.sort((a, b) => {
        const aName = a.name.toLowerCase();
        const bName = b.name.toLowerCase();
        const searchLower = searchTerm.toLowerCase();

        const aExact = aName === searchLower;
        const bExact = bName === searchLower;
        const aStarts = aName.startsWith(searchLower);
        const bStarts = bName.startsWith(searchLower);

        if (aExact && !bExact) return -1;
        if (!aExact && bExact) return 1;
        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;
        
        return aName.localeCompare(bName);
      });

      return allModels.slice(0, 50); // Limit results
    }
  } catch (error) {
    console.error("Error searching models:", error);
    return [];
  }
};

/**
 * Get brand statistics - NEW FUNCTION
 */
export const getBrandStatistics = async (vendorId) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(productsRef, where("vendorId", "==", vendorId));
    const querySnapshot = await getDocs(q);

    const brandStats = {};
    let totalProducts = 0;

    querySnapshot.forEach((doc) => {
      const product = doc.data();
      totalProducts++;
      
      const productBrands = Array.isArray(product.brands) ? product.brands : 
                           (product.brand ? [product.brand] : []);

      productBrands.forEach(brandId => {
        if (!brandStats[brandId]) {
          brandStats[brandId] = {
            productCount: 0,
            totalValue: 0,
            totalStock: 0
          };
        }
        
        brandStats[brandId].productCount++;
        brandStats[brandId].totalValue += (product.price || 0) * (product.stock || 0);
        brandStats[brandId].totalStock += (product.stock || 0);
      });
    });

    return {
      brandStats,
      totalProducts,
      totalBrands: Object.keys(brandStats).length
    };
  } catch (error) {
    console.error("Error getting brand statistics:", error);
    throw error;
  }
};



/**
 * Update product stock for sales (decrease stock)
 */
export const updateProductStockForSale = async (items) => {
  const stockUpdates = [];
  
  try {
    for (const item of items) {
      if (item.productId) {
        const productRef = doc(db, 'products', item.productId);
        const productSnap = await getDoc(productRef);
        
        if (productSnap.exists()) {
          const currentStock = productSnap.data().stock || 0;
          const quantitySold = parseInt(item.quantity);
          const newStock = Math.max(0, currentStock - quantitySold); // Prevent negative stock
          
          await updateDoc(productRef, {
            stock: newStock,
            updatedAt: Timestamp.fromDate(new Date()),
            lastStockUpdate: {
              reason: 'sale',
              timestamp: Timestamp.fromDate(new Date()),
              previousStock: currentStock,
              newStock: newStock,
              quantityChanged: -quantitySold,
              invoiceType: 'sales'
            }
          });
          
          stockUpdates.push({
            productId: item.productId,
            productName: item.name,
            previousStock: currentStock,
            newStock: newStock,
            quantitySold: quantitySold,
            saleAmount: item.amount
          });
          
          console.log(`Stock updated for sale - ${item.name}: ${currentStock} -> ${newStock} (sold: ${quantitySold})`);
        }
      }
    }
    
    return stockUpdates;
  } catch (error) {
    console.error('Error updating product stock for sale:', error);
    throw error;
  }
};

/**
 * Update product stock for purchases (increase stock)
 */
export const updateProductStockForPurchase = async (items) => {
  const stockUpdates = [];
  
  try {
    for (const item of items) {
      if (item.type === 'existing' && item.productId) {
        const productRef = doc(db, 'products', item.productId);
        const productSnap = await getDoc(productRef);
        
        if (productSnap.exists()) {
          const currentStock = productSnap.data().stock || 0;
          const quantityPurchased = parseInt(item.quantity);
          const newStock = currentStock + quantityPurchased;
          
          await updateDoc(productRef, {
            stock: newStock,
            updatedAt: Timestamp.fromDate(new Date()),
            lastStockUpdate: {
              reason: 'purchase',
              timestamp: Timestamp.fromDate(new Date()),
              previousStock: currentStock,
              newStock: newStock,
              quantityChanged: quantityPurchased,
              invoiceType: 'purchase'
            }
          });
          
          stockUpdates.push({
            productId: item.productId,
            productName: item.productName,
            previousStock: currentStock,
            newStock: newStock,
            quantityPurchased: quantityPurchased,
            purchaseAmount: item.amount
          });
          
          console.log(`Stock updated for purchase - ${item.productName}: ${currentStock} -> ${newStock} (purchased: ${quantityPurchased})`);
        }
      }
    }
    
    return stockUpdates;
  } catch (error) {
    console.error('Error updating product stock for purchase:', error);
    throw error;
  }
};

/**
 * Check stock availability for sales
 */
export const checkStockAvailability = async (items) => {
  const stockCheck = {
    available: true,
    issues: []
  };
  
  try {
    for (const item of items) {
      if (item.productId) {
        const productRef = doc(db, 'products', item.productId);
        const productSnap = await getDoc(productRef);
        
        if (productSnap.exists()) {
          const currentStock = productSnap.data().stock || 0;
          const requestedQuantity = parseInt(item.quantity);
          
          if (currentStock < requestedQuantity) {
            stockCheck.available = false;
            stockCheck.issues.push({
              productId: item.productId,
              productName: item.name,
              currentStock: currentStock,
              requestedQuantity: requestedQuantity,
              shortfall: requestedQuantity - currentStock
            });
          }
        } else {
          stockCheck.available = false;
          stockCheck.issues.push({
            productId: item.productId,
            productName: item.name,
            error: 'Product not found'
          });
        }
      }
    }
    
    return stockCheck;
  } catch (error) {
    console.error('Error checking stock availability:', error);
    throw error;
  }
};

/**
 * Get stock movement history for a product
 */
export const getProductStockHistory = async (productId, limit = 10) => {
  try {
    // Since we're storing lastStockUpdate in the product document,
    // for full history we'd need to create a separate stockMovements collection
    // For now, return the last stock update info
    const productRef = doc(db, 'products', productId);
    const productSnap = await getDoc(productRef);
    
    if (productSnap.exists()) {
      const data = productSnap.data();
      const history = [];
      
      if (data.lastStockUpdate) {
        history.push({
          id: 'last_update',
          timestamp: data.lastStockUpdate.timestamp,
          reason: data.lastStockUpdate.reason,
          previousStock: data.lastStockUpdate.previousStock,
          newStock: data.lastStockUpdate.newStock,
          quantityChanged: data.lastStockUpdate.quantityChanged,
          invoiceType: data.lastStockUpdate.invoiceType
        });
      }
      
      return history;
    }
    
    return [];
  } catch (error) {
    console.error('Error getting product stock history:', error);
    throw error;
  }
};

/**
 * Bulk stock validation for multiple products
 */
export const validateBulkStockAvailability = async (invoiceItems) => {
  const results = {
    canProceed: true,
    totalIssues: 0,
    itemResults: []
  };
  
  try {
    for (const item of invoiceItems) {
      if (item.productId && item.quantity > 0) {
        const productRef = doc(db, 'products', item.productId);
        const productSnap = await getDoc(productRef);
        
        const itemResult = {
          productId: item.productId,
          productName: item.name,
          requestedQuantity: parseInt(item.quantity),
          available: false,
          currentStock: 0,
          canSell: false
        };
        
        if (productSnap.exists()) {
          const currentStock = productSnap.data().stock || 0;
          itemResult.currentStock = currentStock;
          itemResult.available = true;
          itemResult.canSell = currentStock >= parseInt(item.quantity);
          
          if (!itemResult.canSell) {
            results.canProceed = false;
            results.totalIssues++;
          }
        } else {
          results.canProceed = false;
          results.totalIssues++;
        }
        
        results.itemResults.push(itemResult);
      }
    }
    
    return results;
  } catch (error) {
    console.error('Error validating bulk stock availability:', error);
    throw error;
  }
};

/**
 * Update product sales tracking when items are sold
 */
export const updateProductSalesTracking = async (items) => {
  try {
    const batch = writeBatch(db);
    
    for (const item of items) {
      if (item.productId) {
        const productRef = doc(db, 'products', item.productId);
        
        // Update sales count and total sales amount
        batch.update(productRef, {
          sales: increment(parseInt(item.quantity)),
          totalSalesAmount: increment(parseFloat(item.amount) || 0),
          lastSaleDate: Timestamp.fromDate(new Date()),
          updatedAt: Timestamp.fromDate(new Date())
        });
      }
    }
    
    await batch.commit();
    console.log('Product sales tracking updated successfully');
  } catch (error) {
    console.error('Error updating product sales tracking:', error);
    throw error;
  }
};

/**
 * Get products with low stock alert
 */
export const getProductsWithLowStockAlert = async (vendorId) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(
      productsRef,
      where("vendorId", "==", vendorId),
      orderBy("stock", "asc")
    );

    const querySnapshot = await getDocs(q);
    const lowStockProducts = [];

    querySnapshot.forEach((doc) => {
      const product = doc.data();
      const stock = product.stock || 0;
      const lowStockThreshold = product.lowStockThreshold || 10;
      
      if (stock <= lowStockThreshold) {
        lowStockProducts.push({
          id: doc.id,
          ...product,
          imageUrls: Array.isArray(product.imageUrls) ? product.imageUrls : [],
          brands: Array.isArray(product.brands) ? product.brands : (product.brand ? [product.brand] : []),
          stockStatus: stock <= 0 ? 'out-of-stock' : 'low-stock',
          urgency: stock <= 0 ? 'critical' : stock <= 5 ? 'high' : 'medium'
        });
      }
    });

    return lowStockProducts;
  } catch (error) {
    console.error("Error getting products with low stock alert:", error);
    throw error;
  }
};

/**
 * Enhanced product statistics with sales and purchase data
 */
export const getEnhancedProductStatistics = async (vendorId) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(productsRef, where("vendorId", "==", vendorId));

    const querySnapshot = await getDocs(q);

    let totalProducts = 0;
    let totalInventoryValue = 0;
    let totalSalesValue = 0;
    let lowStockProducts = 0;
    let outOfStockProducts = 0;
    let totalItemsSold = 0;

    querySnapshot.forEach((doc) => {
      const product = doc.data();
      totalProducts++;
      
      const stock = product.stock || 0;
      const price = product.price || 0;
      const sales = product.sales || 0;
      const totalSalesAmount = product.totalSalesAmount || 0;
      const lowStockThreshold = product.lowStockThreshold || 10;

      // Calculate inventory value
      totalInventoryValue += price * stock;
      
      // Calculate total sales
      totalSalesValue += totalSalesAmount;
      totalItemsSold += sales;

      // Check stock levels
      if (stock <= 0) {
        outOfStockProducts++;
      } else if (stock <= lowStockThreshold) {
        lowStockProducts++;
      }
    });

    return {
      totalProducts,
      totalInventoryValue,
      totalSalesValue,
      totalItemsSold,
      lowStockProducts,
      outOfStockProducts,
      averageProductValue: totalProducts > 0 ? totalInventoryValue / totalProducts : 0,
      stockHealthScore: totalProducts > 0 ? ((totalProducts - outOfStockProducts - lowStockProducts) / totalProducts) * 100 : 0
    };
  } catch (error) {
    console.error("Error getting enhanced product statistics:", error);
    throw error;
  }
};


/**
 * Generate barcode function
 */
export const generateBarcode = () => {
  const timestamp = Date.now().toString();
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `${timestamp.slice(-6)}${random}`;
};

/**
 * Add Category Function
 */
export const addProductCategory = async (categoryData) => {
  try {
    let imageUrl = null;

    // Upload image if provided
    if (categoryData.image && categoryData.image instanceof File) {
      const imageRef = ref(storage, `categories/${Date.now()}_${categoryData.image.name}`);
      
      const snapshot = await uploadBytes(imageRef, categoryData.image);
      imageUrl = await getDownloadURL(snapshot.ref);
    }

    // Prepare category document
    const categoryDoc = {
      name: categoryData.name.trim(),
      description: categoryData.description?.trim() || '',
      image: imageUrl,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };

    // Add to Firestore
    const docRef = await addDoc(collection(db, 'categories'), categoryDoc);
    
    return {
      id: docRef.id,
      ...categoryDoc
    };
  } catch (error) {
    console.error('Error adding category:', error);
    throw new Error('Failed to add category: ' + error.message);
  }
};

/**
 * Add Brand Function
 */
export const addProductBrand = async (brandData) => {
  try {
    let logoUrl = null;

    // Upload logo if provided
    if (brandData.logo && brandData.logo instanceof File) {
      const logoRef = ref(storage, `brands/${Date.now()}_${brandData.logo.name}`);
      
      const snapshot = await uploadBytes(logoRef, brandData.logo);
      logoUrl = await getDownloadURL(snapshot.ref);
    }

    // Prepare brand document
    const brandDoc = {
      name: brandData.name.trim(),
      description: brandData.description?.trim() || '',
      logo: logoUrl,
      website: brandData.website?.trim() || '',
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };

    // Add to Firestore
    const docRef = await addDoc(collection(db, 'brands'), brandDoc);
    
    return {
      id: docRef.id,
      ...brandDoc
    };
  } catch (error) {
    console.error('Error adding brand:', error);
    throw new Error('Failed to add brand: ' + error.message);
  }
};

/**
 * Update existing addProduct function to include barcode - ENHANCED VERSION
 */
export const addProductWithBarcode = async (productData, vendorId) => {
  try {
    console.log('Adding product with barcode support:', productData);
    
    // Generate barcode if not provided
    let barcode = productData.barcode;
    if (!barcode) {
      barcode = generateBarcode();
      console.log('Generated barcode:', barcode);
    }

    // Extract images from productData to handle separately
    const { images, ...productDataWithoutImages } = productData;
    
    // Ensure brands is always an array
    const processedData = {
      ...productDataWithoutImages,
      barcode: barcode, // Include barcode
      brands: Array.isArray(productDataWithoutImages.brands) 
        ? productDataWithoutImages.brands 
        : (productDataWithoutImages.brand ? [productDataWithoutImages.brand] : []),
      createdAt: new Date(),
      updatedAt: new Date(),
      imageUrls: [], // Initialize empty imageUrls array
      vendorId: vendorId
    };

    // Remove old brand field if it exists (we now use brands array)
    if (processedData.brand) {
      delete processedData.brand;
    }

    console.log('Adding product to Firestore with processed data:', processedData);
    
    // Add to Firestore first (without images)
    const docRef = await addDoc(collection(db, "products"), processedData);
    console.log('Product added to Firestore with ID:', docRef.id);

    // Upload images if available
    let imageUrls = [];

    if (images && images.length > 0) {
      console.log('Uploading images...');
      
      for (const [index, image] of images.entries()) {
        const imageRef = ref(storage, `products/${docRef.id}/images/${Date.now()}_${index}_${image.name}`);
        const snapshot = await uploadBytes(imageRef, image);
        const downloadURL = await getDownloadURL(snapshot.ref);
        imageUrls.push(downloadURL);
        console.log(`Uploaded image ${index + 1}:`, downloadURL);
      }
      
      // Update product with image URLs
      console.log('Updating product with image URLs:', imageUrls);
      await updateDoc(docRef, { imageUrls });
    }

    // Update vendor's product count
    console.log('Updating vendor product count...');
    const vendorRef = doc(db, "vendors", vendorId);
    await updateDoc(vendorRef, {
      totalProducts: increment(1),
    });

    console.log('Product added successfully with barcode:', barcode);

    // Return the created product
    return {
      id: docRef.id,
      ...processedData,
      imageUrls,
    };
  } catch (error) {
    console.error("Error adding product with barcode:", error);
    throw new Error(`Failed to add product: ${error.message}`);
  }
};

/**
 * Update existing updateProduct function to handle barcode - ENHANCED VERSION
 */
export const updateProductWithBarcode = async (productId, productData) => {
  try {
    console.log('Updating product with barcode support:', productId, productData);
    
    const productRef = doc(db, "products", productId);

    // Get current product data
    const currentProductSnap = await getDoc(productRef);
    if (!currentProductSnap.exists()) {
      throw new Error('Product not found');
    }
    
    const currentData = currentProductSnap.data();
    let currentImageUrls = Array.isArray(currentData.imageUrls) ? [...currentData.imageUrls] : [];
    
    console.log('Current image URLs:', currentImageUrls);

    // Extract images from productData
    const { images, removedImageIndexes, ...productDataWithoutImages } = productData;

    // Ensure barcode is preserved or generated
    let barcode = productDataWithoutImages.barcode || currentData.barcode;
    if (!barcode) {
      barcode = generateBarcode();
      console.log('Generated new barcode for update:', barcode);
    }

    // Ensure brands is always an array
    const processedData = {
      ...productDataWithoutImages,
      barcode: barcode, // Include/update barcode
      brands: Array.isArray(productDataWithoutImages.brands) 
        ? productDataWithoutImages.brands 
        : (productDataWithoutImages.brand ? [productDataWithoutImages.brand] : []),
    };

    // Remove old brand field if it exists
    if (processedData.brand) {
      delete processedData.brand;
    }

    // Handle removed images first
    if (removedImageIndexes && removedImageIndexes.length > 0) {
      console.log('Removing images at indexes:', removedImageIndexes);
      
      // Get URLs of images to be removed
      const imagesToRemove = removedImageIndexes
        .filter(index => index < currentImageUrls.length)
        .map(index => currentImageUrls[index]);
      
      console.log('Images to be removed:', imagesToRemove);
      
      // Delete from storage
      if (imagesToRemove.length > 0) {
        await deleteImages(imagesToRemove);
      }
      
      // Remove from current URLs array
      currentImageUrls = currentImageUrls.filter((_, index) => 
        !removedImageIndexes.includes(index)
      );
      
      console.log('Remaining image URLs after removal:', currentImageUrls);
    }

    // Upload new images if available
    if (images && images.length > 0) {
      console.log('Uploading new images:', images.length);
      
      for (const [index, image] of images.entries()) {
        const imageRef = ref(storage, `products/${productId}/images/${Date.now()}_${currentImageUrls.length + index}_${image.name}`);
        const snapshot = await uploadBytes(imageRef, image);
        const downloadURL = await getDownloadURL(snapshot.ref);
        currentImageUrls.push(downloadURL);
        console.log(`Uploaded new image ${index + 1}:`, downloadURL);
      }
    }

    // Prepare update data
    const updateData = {
      ...processedData,
      imageUrls: currentImageUrls,
      updatedAt: new Date(),
    };

    console.log('Final update data:', updateData);

    // Update Firestore document
    await updateDoc(productRef, updateData);
    console.log('Product updated successfully with barcode:', barcode);

    // Return the updated product
    return {
      id: productId,
      ...updateData,
    };
  } catch (error) {
    console.error("Error updating product with barcode:", error);
    throw new Error(`Failed to update product: ${error.message}`);
  }
};

/**
 * Validate barcode uniqueness
 */
export const validateBarcodeUnique = async (barcode, excludeProductId = null) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(productsRef, where("barcode", "==", barcode));
    const querySnapshot = await getDocs(q);

    let isDuplicate = false;
    querySnapshot.forEach((doc) => {
      if (excludeProductId && doc.id === excludeProductId) {
        // Exclude the current product when updating
        return;
      }
      isDuplicate = true;
    });

    return !isDuplicate;
  } catch (error) {
    console.error('Error validating barcode uniqueness:', error);
    return true; // Allow if validation fails
  }
};

/**
 * Search products by barcode
 */
export const searchProductsByBarcode = async (vendorId, barcode) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(
      productsRef,
      where("vendorId", "==", vendorId),
      where("barcode", "==", barcode)
    );

    const querySnapshot = await getDocs(q);
    const products = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      products.push({
        id: doc.id,
        ...data,
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
      });
    });

    return products;
  } catch (error) {
    console.error('Error searching products by barcode:', error);
    throw error;
  }
};

/**
 * Generate batch barcodes for multiple products
 */
export const generateBatchBarcodes = (count) => {
  const barcodes = [];
  for (let i = 0; i < count; i++) {
    barcodes.push(generateBarcode());
    // Add small delay to ensure uniqueness
    if (i < count - 1) {
      new Promise(resolve => setTimeout(resolve, 1));
    }
  }
  return barcodes;
};

/**
 * Update multiple products with barcodes
 */
export const updateProductsWithBarcodes = async (updates) => {
  try {
    const batch = writeBatch(db);

    updates.forEach(({ productId, barcode }) => {
      const productRef = doc(db, "products", productId);
      batch.update(productRef, {
        barcode,
        updatedAt: new Date(),
      });
    });

    await batch.commit();
    return true;
  } catch (error) {
    console.error("Error updating products with barcodes:", error);
    throw error;
  }
};

/**
 * Get products without barcodes
 */
export const getProductsWithoutBarcodes = async (vendorId) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(
      productsRef,
      where("vendorId", "==", vendorId),
      where("barcode", "==", null)
    );

    const querySnapshot = await getDocs(q);
    const products = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      products.push({
        id: doc.id,
        ...data,
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
      });
    });

    return products;
  } catch (error) {
    console.error('Error getting products without barcodes:', error);
    
    // Fallback: get all products and filter client-side
    try {
      const productsRef = collection(db, "products");
      const q = query(productsRef, where("vendorId", "==", vendorId));
      const querySnapshot = await getDocs(q);
      const products = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        if (!data.barcode) {
          products.push({
            id: doc.id,
            ...data,
            imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
            brands: Array.isArray(data.brands) ? data.brands : (data.brand ? [data.brand] : [])
          });
        }
      });

      return products;
    } catch (fallbackError) {
      console.error('Fallback query also failed:', fallbackError);
      throw fallbackError;
    }
  }
};

// Export functions
// Update your default export to include the new functions
export default {
  getProducts,
  getProductsSimple,
  getProductById,
  addProduct,
  updateProduct,
  deleteProduct,
  updateProductStock,
  getProductCategories,
  getProductBrands,
  getLowStockProducts,
  getProductStatistics,
  getRecentlyAddedProducts,
  getBestSellingProducts,
  updateBulkStock,
  searchProductsByModel,
  getProductsByBrands,
  getBrandStatistics,
  getModelsByBrands,
  getAllModels,
  searchModelsByName,
  // Add the new stock management functions
  updateProductStockForSale,
  updateProductStockForPurchase,
  checkStockAvailability,
  getProductStockHistory,
  validateBulkStockAvailability,
  updateProductSalesTracking,
  getProductsWithLowStockAlert,
  getEnhancedProductStatistics,
   addProductCategory,
  addProductBrand,
  addProductWithBarcode,
  updateProductWithBarcode,
  generateBarcode,
  validateBarcodeUnique,
  searchProductsByBarcode,
  generateBatchBarcodes,
  updateProductsWithBarcodes,
  getProductsWithoutBarcodes,
};